"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let FieldsetContractRentalData = class FieldsetContractRentalData extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    contract;
    onContract(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("contract");
    }
    labelAlign;
    onLabel_align(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("labelAlign");
    }
    noLegend;
    onNo_legend(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("noLegend");
    }
    rental;
    async $$load_rental() {
        return this.contract.rental || {};
    }
    ux;
    b_1040167445267876_dataSource;
    dataMembers = ['rental', 'ux', 'b_1040167445267876_dataSource'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                rental: null,
                ux: null,
                b_1040167445267876_dataSource: {
                    name: "suggest_rental",
                },
            },
        };
    }
    get rentalRequired() {
        if (this.loaded) {
            return ['rental', 'rental_agreement', 'parking'].indexOf(this.contract.contract_type) > -1;
        }
        return null;
    }
    async evh_7315092382398562_reload(event, scope) {
        return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_setData_8710_getActionArgs($event) {
        return {
            path: "contract.rental",
            value: null,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_1040167445267876_optionDeselected(event, scope) {
        return await this.actions.evh_1040167445267876_optionDeselected.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_setData_8714_getActionArgs($event) {
        return {
            path: "contract.rental",
            value: $event.data.response.data,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_1040167445267876_request_8712_getActionArgs($event) {
        return {
            operation: "read_rental",
            parameters: {
                id: $event.data.value.id,
            },
            headers: {
                accept: "application/vnd.itp.rentalparty+json",
            },
        };
    }
    async evh_1040167445267876_optionSelected(event, scope) {
        return await this.actions.evh_1040167445267876_optionSelected.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_reloadComponentData_8708 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7315092382398562_reload_8707 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_reloadComponentData_8708,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_7315092382398562_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_reload_8707],
        });
        const act_1040167445267876_setData_8710 = new core_1.actions.SetDataAction({
            actionArgs: this.act_1040167445267876_setData_8710_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_optionDeselected_8709 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_setData_8710,
            event: "optionDeselected",
            displayName: "setData",
        });
        const evh_1040167445267876_optionDeselected = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_optionDeselected_8709],
        });
        const act_1040167445267876_setData_8714 = new core_1.actions.SetDataAction({
            actionArgs: this.act_1040167445267876_setData_8714_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_8713 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_setData_8714,
            event: "success",
            displayName: "setData",
        });
        const act_1040167445267876_request_8712 = new core_1.actions.RequestAction({
            actionArgs: this.act_1040167445267876_request_8712_getActionArgs,
            events: [evh_1040167445267876_success_8713],
        });
        const evh_1040167445267876_optionSelected_8711 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_request_8712,
            event: "optionSelected",
            displayName: "request",
        });
        const evh_1040167445267876_optionSelected = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_optionSelected_8711],
        });
        return {
            act_7315092382398562_reloadComponentData_8708,
            evh_7315092382398562_reload_8707,
            evh_7315092382398562_reload,
            act_1040167445267876_setData_8710,
            evh_1040167445267876_optionDeselected_8709,
            evh_1040167445267876_optionDeselected,
            act_1040167445267876_setData_8714,
            evh_1040167445267876_success_8713,
            act_1040167445267876_request_8712,
            evh_1040167445267876_optionSelected_8711,
            evh_1040167445267876_optionSelected,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], FieldsetContractRentalData.prototype, "contract", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('contract'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], FieldsetContractRentalData.prototype, "onContract", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "right",
    }),
    __metadata("design:type", String)
], FieldsetContractRentalData.prototype, "labelAlign", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('labelAlign'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], FieldsetContractRentalData.prototype, "onLabel_align", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
    }),
    __metadata("design:type", Boolean)
], FieldsetContractRentalData.prototype, "noLegend", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('noLegend'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], FieldsetContractRentalData.prototype, "onNo_legend", null);
FieldsetContractRentalData = __decorate([
    (0, vue_property_decorator_1.Component)()
], FieldsetContractRentalData);
exports.default = FieldsetContractRentalData;
vue_property_decorator_1.Vue.component("FieldsetContractRentalData", FieldsetContractRentalData);
